<template>
  <div id="luckylist" class="relativeItem">
    <img class="imgBlock noevents-img" src="../../assets/list/bump(3).jpg" />
    <!--活动规则-->
    <div class="absoluteItem role-img" @click="show_role = true" >
      <img class="imgBlock noevents-img" src="../../assets/list/bump(1).png"/>
    </div>

    <!--列表-->
    <div class="listshell" id="u">
      <div class="list lucky-shell">
        <ul id="u1" class="lucky-list">
          <li
            class="flex-box"
            v-for="(n, index) in lucky_list"
            :key="index"
            :class="{darkbk:index%2 == 0}"
          >
            <div class="flex-box info">
              <img :src="n.avatar" />
              <p class="apostrophe">{{ n.nickname }}</p>
            </div>
            <div class="num">{{ n.num }}&nbsp;次</div>
          </li>
        </ul>

        <!--显示活动未开启-->
        <p class="none absoluteItem centerImg" v-if="none">暂无幸运用户上榜</p>
      </div>
    </div>

    <!--底部-->
    <div class="bottom relativeItem">
      <img class="imgBlock noevents-img" src="../../assets/list/bump(2).jpg" />
      <div class="absoluteItem centerX b-div" @click="show_record = true">
        <img class="imgBlock noevents-img" src="../../assets/list/bump(2).png" />
      </div>
      <p class="absoluteItem centerX">本活动最终解释权归平台所有</p>
    </div>

    <!--记录-->
    <div class="tc recordtc" v-show="show_record" @click="show_record = false">
      <div class="main absoluteItem centerImg" @click.stop>
        <img class="imgBlock noevents-img" src="../../assets/list/bum(1).png" />
        <img
          class="imgBlock noevents-img title absoluteItem centerX"
          src="../../assets/list/bum(3).png"
        />
        <img class="list-title absoluteItem centerX" src="../../assets/list/bum(1).jpg" />
        <!--关闭按钮-->
        <img
          class="closeimg absoluteItem centerX"
          src="../../assets/list/bump(3).png"
          @click="show_record = false"
        />
        <!--列表-->
        <div class="inset-lists-shell absoluteItem centerX">
          <ul class="inset-lists">
            <li
              class="flex-box"
              v-for="(n, index) in my_lucky_list"
              :key="index"
              :class="{darkbk:index%2 == 0}"
            >
              <p>{{ n.addtime }}</p>
              <p>
                {{ n.luckprice }}&nbsp;
                <span>钻石</span>
              </p>
            </li>
          </ul>
        </div>

        <!--显示活动未开启-->
        <p class="none absoluteItem centerImg" v-if="my_none">暂无暴击记录</p>
      </div>
    </div>

    <!--规则-->
    <div class="tc roletc" v-if="show_role" @click="show_role = false">
      <div class="main absoluteItem centerImg" @click.stop>
        <img class="imgBlock noevents-img" src="../../assets/list/bum(1).png" />
        <img
          class="imgBlock noevents-img title absoluteItem centerX"
          src="../../assets/list/bum(2).png"
        />
        <!--关闭按钮-->
        <img
          class="closeimg absoluteItem centerX"
          src="../../assets/list/bump(3).png"
          @click="show_role = false"
        />

        <!--文本-->
        <ul class="absoluteItem centerX">
          <li>暴击规则：</li>
          <li>1.赠送幸运礼物参与幸运大暴击活动。</li>
          <li>
            2.每个用户在送出幸运礼物的过程中，有一定几率获取幸运大暴击。
          </li>
          <li>
            3.获取幸运大暴击的用户，将获得丰厚的钻石反馈。
          </li>
          <li>
            3.凡以不正当手段（包括但不限于机器刷奖、作弊、扰乱系统、实施网络攻击等）参与本次活动的用户，平台有权终止其参与活动，取消其获奖资格（如奖励已发放，本公司有权收回），若让其它用户产生了损失，平台将配合追责，并永久封号。
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>















<script>
export default {
  name: "celelist",
  data() {
    return {
      none: false,
      my_none: false,
      show_role: false,
      show_record: false,
      lucky_page: 1,
      lucky_size: 30,
      lucky_list: [],
      is_lucky_list_more: true,
      my_lucky_page: 1,
      my_lucky_size: 30,
      my_lucky_list: [],
      is_my_lucky_list_more: true
    };
  },
  methods: {
    /**获取列表 */
    getList() {
      if (!this.is_lucky_list_more) {
        return;
      } else {
        this.is_lucky_list_more = false;
      }
      let _this = this;
      let data = {
        pagesize: _this.lucky_size,
        page: _this.lucky_page
      };
      this.$jsonp(this.$apis("lucky"), data, res => {
        _this.startVal = _this.endVal;
        _this.endVal = res.data.data.result.luckpircie;
        _this.show_number = true;
        if (res.data.data.result.list.length != 0) {
          _this.is_lucky_list_more = true;
          for (const i of res.data.data.result.list) {
            _this.lucky_list.push(i);
          }
        } else {
          if (_this.lucky_page == 1) {
            _this.none = true;
          }
          _this.is_lucky_list_more = false;
        }
      });
    },

    /**给两个列表外壳添加滚动监听事件 */
    lucky_scroll() {
      let item = document.getElementsByClassName("lucky-shell")[0];
      let list = document.getElementsByClassName("lucky-list")[0];
      let height = null;
      let _this = this;
      item.addEventListener("scroll", e => {
        height = list.offsetHeight;
        if (height - item.offsetHeight - e.path[0].scrollTop <= 100) {
          if (_this.is_lucky_list_more) {
            _this.lucky_page++;
            _this.getList();
          }
        }
      });
    },
    mylucky_scroll() {
      let item = document.getElementsByClassName("inset-lists-shell")[0];
      let list = document.getElementsByClassName("inset-lists")[0];
      let height = null;
      let _this = this;
      item.addEventListener("scroll", e => {
        height = list.offsetHeight;
        if (height - item.offsetHeight - e.path[0].scrollTop <= 100) {
          if (_this.is_my_lucky_list_more) {
            _this.my_lucky_page++;
            _this.get_myList();
          }
        }
      });
    },

    /**获取个人列表 */
    get_myList() {
      if (!this.is_my_lucky_list_more) {
        return;
      } else {
        this.is_my_lucky_list_more = false;
      }
      let _this = this;
      let data = {
        pagesize: _this.my_lucky_size,
        page: _this.my_lucky_page
      };
      this.$jsonp(this.$apis("myLucky"), data, res => {
        if (res.data.data.result.list.length != 0) {
          _this.is_my_lucky_list_more = true;
          for (const i of res.data.data.result.list) {
            _this.my_lucky_list.push(i);
          }
        } else {
          if (_this.my_lucky_page == 1) {
            _this.my_none = true;
          }
          _this.is_my_lucky_list_more = false;
        }
      });
    },

    /**点击显示个人中将信息
     * 没登录就跳登录
     */
    show_my_lucky() {
      if (
        !this.$tool.isStr(this.$cookie.getC("token")) &&
        this.$cookie.getC("platform") != "app"
      ) {
        //让用户跳转登录
        this.$router.push({ path: "/login?repath=true" });
      } else {
        this.show_record = true;
      }
    },

    /**无缝滚动 */
    roll: function() {
      let u = this.$tool.getByID("u"),
        u1 = this.$tool.getByID("u1");
      var height = u1.offsetHeight;
      setInterval(function() {
        if (u.scrollTop >= height) {
          u.scrollTop = 0;
        }
        u.scrollTop += 1;
      }, 100);
    }
  },
  mounted: function() {
    this.$tool.setTitle("幸运礼物暴击周榜");
    this.getList();
    this.lucky_scroll();
    this.get_myList();
    this.mylucky_scroll();
  }
};
</script>



















<style scoped>
.role-img {
  top: 8%;
  right: 0;
  width: 19%;
}
.listshell {
  height: 500px;
  background: url("../../assets/list/bump(1).jpg") no-repeat left top;
  background-size: 100% 100%;
}
.listshell .none,
.recordtc .none{
  font-size: 14px;
  width: 100%;
  max-width: 100% !important;
  text-align: center;
  color: rgba(255, 255, 255, .6);
}
.bottom p {
  font-size: 12px;
  color: #a894a6;
  bottom: 10%;
  width: 100%;
  text-align: center;
}
.b-div {
  width: 60%;
  top: 4%;
}

/**列表 */
.list {
  max-height: 92%;
  overflow-y: scroll;
}
.list li {
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  width: 89%;
  padding: 9px 12%;
}
.darkbk {
  background: #430c77 !important;
}
.list img {
  border-radius: 50%;
  width: 42px;
  height: 42px;
  margin-right: 10px;
  background: url("../../assets/list/bump.png") no-repeat left top;
  background-size: 100% 100%;
  padding: 1px;
}
.list ul {
  /* max-height: 70%; */
  overflow-y: scroll;
}
.list .info {
  font-size: 15px;
  color: white;
  align-items: center;
}
.list p {
  max-width: 100px;
}
.list .num {
  font-size: 17px;
  color: #fadb5f;
  font-family: kefu;
}

/**记录 */
.recordtc .main,
.roletc .main {
  width: 93%;
  transform-origin: left top;
  animation: adAnimation 0.2s forwards;
}
.tc .title {
  width: 10.75rem;
  height: 3.0625rem;
  top: -1%;
}
.list-title {
  width: 88%;
  top: 12%;
}
.recordtc .inset-lists-shell {
  width: 88%;
  max-height: 64%;
  top: 24%;
  overflow-y: scroll;
}
.recordtc li {
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;
  padding-left: 10%;
  padding-right: 10%;
}
.recordtc li p:first-child {
  font-size: 13px;
  color: white;
}
.recordtc li p:last-child {
  font-size: 16px;
  color: #fadb5f;
  font-weight: bold;
}
.recordtc li p:last-child span {
  font-size: 14px;
}
.closeimg {
  width: 9%;
  bottom: -10%;
}


/**规则 */
.roletc ul {
  width: 75%;
  top: 12%;
  font-size: 14px;
  color: white;
  text-align: justify;
}
.roletc li {
  margin-bottom: 7px;
}
</style>
